import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { SolicitudResultadoBusqueda } from 'src/app/models/solicitud/solicitudResultadoBusqueda';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { ISolicitudCompletarModel } from 'src/app/models/interfaces/solicitud/ISolicitudCompletarModel';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { IFilterSolicitudModel } from 'src/app/models/interfaces/solicitud/IFilterSolicitudModel';
import { ISolicitudValidarModel } from 'src/app/models/interfaces/solicitud/ISolicitudValidarModel';
import { ISolicitudExtenderModel } from 'src/app/models/interfaces/solicitud/ISolicitudExtenderModel';
import { ISolicitudAmpliarPersonalModel } from 'src/app/models/interfaces/solicitud/ISolicitudAmpliarPersonalModel';
import { ISolicitudDerivarModel } from 'src/app/models/interfaces/solicitud/ISolicitudDerivarModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { ISolicitudStandByModel } from 'src/app/models/interfaces/solicitud/ISolicitudStandByModel';
import { ISolicitudAutorizarAccesoModel } from 'src/app/models/interfaces/solicitud/ISolicitudAutorizarAccesoModel';
import { ISolicitudAdicionarInfoModel } from 'src/app/models/interfaces/solicitud/ISolicitudAdicionarInfoModel';

@Injectable({
  providedIn: 'root',
})
export class SolicitudService {
  // private configUrl = 'api/solicitudes';
  // private configDocumentacionUrl = 'api/documentos';
  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');
  private configUrlToExport = [environment.apiGatewayUrl, 'solicitudes', 'exportar'].join('/');
  private configDerivadosUrl = [environment.apiGatewayUrl, 'solicitudes', 'derivados'].join('/');
  private configDerivadosToExportUrl = [environment.apiGatewayUrl, 'solicitudes', 'derivados', 'exportar'].join('/');
  private configSupervisorUrl = [environment.apiGatewayUrl, 'solicitudes', 'supervisor'].join('/');
  private configSupervisorToExportUrl = [environment.apiGatewayUrl, 'solicitudes', 'supervisor', 'exportar'].join('/');
  private configAdministradorUrl = [environment.apiGatewayUrl, 'solicitudes', 'administrador'].join('/');
  private configAdministradorToExportUrl = [environment.apiGatewayUrl, 'solicitudes', 'administrador', 'exportar'].join('/');
  private configPendienteAutorizacionUrl = [environment.apiGatewayUrl, 'solicitudes', 'pendientesautorizacion'].join('/');
  private configPendienteAutorizacionToExportUrl = [environment.apiGatewayUrl, 'solicitudes', 'pendientesautorizacion', 'exportar'].join('/');
  private configContratistaUrl = [environment.apiGatewayUrl, 'solicitudes', 'contratista'].join('/');
  private configContratistaToExportUrl = [environment.apiGatewayUrl, 'solicitudes', 'contratista', 'exportar'].join('/');
  
  constructor(
    private http: HttpClient,
    private datepipe: DatePipe
    ) {}

  getList(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    queryParams.push(`idTipoFiltro=${model.idTipoFiltro}`);

    return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  exportList(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<HttpResponse<Blob>> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    queryParams.push(`idTipoFiltro=${model.idTipoFiltro}`);

    return this.http.get(`${this.configUrlToExport}/?${queryParams.join('&')}`, { observe: 'response', responseType: 'blob'});
  }

  getListContratista(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(
      this.configContratistaUrl + '?'+ queryParams.join('&')
    );
  }

  getListContratistaToExport(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(this.configContratistaToExportUrl + '?'+ queryParams.join('&'), { responseType: 'blob'});
  }

  getListDerivados(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(
      this.configDerivadosUrl + '?'+ queryParams.join('&')
    );
  }

  getListDerivadosToExport(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(`${this.configDerivadosToExportUrl}/?${queryParams.join('&')}`, { responseType: 'blob'});
  }

  getListPorSupervisor(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    queryParams.push(`idTipoFiltro=${model.idTipoFiltro}`);

    return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(
      this.configSupervisorUrl + '?'+ queryParams.join('&')
    );
  }

  getListPorSupervisorToExport(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    queryParams.push(`idTipoFiltro=${model.idTipoFiltro}`);

    return this.http.get(`${this.configSupervisorToExportUrl}/?${queryParams.join('&')}`, { responseType: 'blob'});
  }

  getListPorAdministrador(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(
      this.configAdministradorUrl + '?'+ queryParams.join('&')
    );
  }

  getListPorAdministradorToExport(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.trabajo !== '') {
      queryParams.push(`trabajo=${model.trabajo}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.estados.length > 0){
      queryParams.push(`estados=${model.estados.join(',')}`); 
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.fechaInicio){
      queryParams.push(`fechaInicioRegistro=${this.datepipe.transform(model.fechaInicio, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFin){
      queryParams.push(`fechaFinRegistro=${this.datepipe.transform(model.fechaFin, 'yyyy-MM-dd')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(`${this.configAdministradorToExportUrl}/?${queryParams.join('&')}`, { responseType: 'blob'});
  }

  getListPendienteAutorizacion(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<SolicitudResultadoBusqueda[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get<SearchResultModel<SolicitudResultadoBusqueda[]>>(
      this.configPendienteAutorizacionUrl + '?'+ queryParams.join('&')
    );
  }

  getListPendienteAutorizacionToExport(
    model: IFilterSolicitudModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (model.codigo !== '') {
      queryParams.push(`codigo=${model.codigo}`);
    }

    if (model.solicitante !== '') {
      queryParams.push(`solicitante=${model.solicitante}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.sedes.length > 0){
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`); 
    }

    return this.http.get(`${this.configPendienteAutorizacionToExportUrl}/?${queryParams.join('&')}`, { responseType: 'blob'});
  }

  getById(id: number): Observable<SolicitudModel> {
    return this.http.get<SolicitudModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ISolicitudModel) {
    return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
  }

  update(model: ISolicitudModel) {
    return this.http.put<ISolicitudModel>(
      `${this.configUrl}/${model.idSolicitud}`,
      model
    );
  }

  updateHeader(model: ISolicitudModel) {
    return this.http.put<ActionResultModel>(
      `${this.configUrl}/${model.idSolicitud}/header`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ActionResultModel>(`${this.configUrl}/${id}`);
  }

  completar(model: ISolicitudCompletarModel){
    return this.http.post<ISolicitudCompletarModel>(`${this.configUrl}/${model.idSolicitud}/completar`, model);
  }

  validar(model: ISolicitudValidarModel){
    return this.http.post<ISolicitudValidarModel>(`${this.configUrl}/${model.idSolicitud}/validar`, model);
  }

  aprobar(model: ISolicitudValidarModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${model.idSolicitud}/aprobar`, model);
  }

  extender(model: ISolicitudExtenderModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${model.idSolicitud}/extender`, model);
  }

  ponerstandby(model: ISolicitudStandByModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${model.idSolicitud}/ponerstandby`, model);
  }

  quitarstandby(model: ISolicitudStandByModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${model.idSolicitud}/quitarstandby`, model);
  }


  ampliarPersonal(model: ISolicitudAmpliarPersonalModel){
    return this.http.post<ISolicitudAmpliarPersonalModel>(`${this.configUrl}/${model.idSolicitud}/ampliar-personal`, model);
  }

  derivar(model: ISolicitudDerivarModel){
    return this.http.post<ISolicitudAmpliarPersonalModel>(`${this.configUrl}/${model.idSolicitud}/derivar`, model);
  }

  autorizar(model: ISolicitudAutorizarAccesoModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/autorizar`, model);
  }

  adicionarinfo(model: ISolicitudAdicionarInfoModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${model.idSolicitud}/adicionar-info`, model);
  }
}
